export default "__VITE_ASSET__BRybFuh7__"